/* eslint-disable max-len */
/** @jsx jsx */

import React, { useEffect, useState } from 'react';
import Appbar from 'components/organismos/Appbar';
import useLoginUser from 'hooks/useLoginUser';
import { Container } from 'react-grid-system';
import TopBar from 'components/atoms/TopBar';
import { useHistory, useLocation } from 'react-router-dom';
import TabBar, { TablItem } from 'components/atoms/TabBar';
import Icon, {IconType} from 'components/atoms/Icon';
import { css, jsx } from '@emotion/core';
import { toast } from 'react-toastify';
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import BodyText from "components/atoms/BodyText";
import BoxGroupMenu from "components/molecules/Menu/BoxGroupMenu";
import { productColor } from 'components/styles';
import { menuListHQ } from './menuData'
import { menuSuperAdministrator } from './menuData'
import TabMenuBar from './TabMenuBar'

const style = {
  container: css({
    width: '100%', 
    maxWidth: '1750px', 
    margin: 'auto', 
    justifyContent: 'space-between', 
    marginTop: '35px',
  }),
  backHistory: css({
    position: 'absolute',
    top: '8px',
    left: '-65px'
  },
    css`&:hover svg{
    opacity:0.7
  }`,
  ),
  boxItem: css({
    padding: "8px 26px", 
    color: "#999999", 
    fontSize: "12px"
  }),
  boxSubItem: css({
    padding: "7px", 
  }),
  logo: css({
    color: "#363D3D",
    fontWeight: "bold",
    fontSize: "18px",
    marginLeft: "7px",
  }),
  logoContainer: css({
    borderBottom: "1px solid #e6e6e6",
    paddingBottom: '20px',
  }),
}

export const checkBoxMenu = (boxMenu: any, url: string) => {
  if(!boxMenu.subMenu){
    return boxMenu.value === url;
  }else{
    return boxMenu.subMenu.filter((boxMenu: any) => checkBoxMenu(boxMenu, url)).length > 0
  }
}

export const checkBoxGroupMenu = (menuList: any, url: string) => {
  return menuList.menuList?.filter((menu: any) => checkBoxMenu(menu, url)).length > 0
}

const Sidebar: React.FC<{
}> = ({ }) => {
  const { staffName } = useLoginUser();

  const location = useLocation();

  const history = useHistory();
  const [indexOpen, setIndexOpen] = useState<number|null>()

 
  
  useEffect(() => {
    let group = location.pathname.split('/')[1];
    let currentMenu: number|null = null;
    menuSuperAdministrator.map((item, index) => {
      if(checkBoxGroupMenu(item, group)){
        currentMenu = index;
      }
    });
    setIndexOpen(currentMenu);
  }, [])

  return (
    <React.Fragment>
      <FlexBoxItem customStyle={css({
        flexDirection: 'column',
        alignSelf: 'flex-start',
        width: '220px',
        position: 'sticky',
        marginTop:'15px',
        top: '80px',
      })}>
        <FlexBox customStyle={style.logoContainer}>
          <Icon type="logoHinata" color={""} verticalAlign="middle" />
          <BodyText customStyle={style.logo}>HINATA</BodyText>
        </FlexBox>
        <div style={{height:'600px', overflowY: 'auto'}}>
          {menuSuperAdministrator.map((groupMenu, index) => {

            return(
              <BoxGroupMenu 
                groupMenu={groupMenu}
                index={index}
                openMenu={index === indexOpen}
                setIndexOpen={(i: number|null) => setIndexOpen(i)}
                level={1}
              />
            )
          })}
        </div>
        
      </FlexBoxItem>
    </React.Fragment>
  );
};

export default Sidebar;
